export enum FraudRiskLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum FraudAnalysisStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
  NotScanned = 'not_scanned',
}

export enum RedactionDisplayStatus {
  Passed = 'passed',
  Failed = 'failed',
  Pending = 'pending',
  NotApplicable = 'not_applicable',
}

export enum AttachmentUploadState {
  Uploading = 'Uploading',
  Quarantined = 'Quarantined',
  Uploaded = 'Uploaded',
  Timeout = 'Timeout',
  Error = 'Error',
}
